import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService, AlertType } from '../lib/lib-ngx/services/alert.service';
import { ErrorService } from '../lib/lib-ngx/services/error.service';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { ApiPublicService } from '../lib/lib-ngx/web-services/api-public.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'impekkable-stock';

  constructor(
    public alertService: AlertService,
    errorService: ErrorService,
    modalService: NgbModal,
    apiPublicService: ApiPublicService,
  ) {
    apiPublicService.get().subscribe();

    errorService.setModal(async (text: String) => {
      await new Promise(resolve => setTimeout(resolve));
      const confirmationModal = modalService.open(ConfirmationModalComponent, {
        size: 'xl' as 'lg',
        backdrop: 'static',
        keyboard: false,
        centered: true,
      });
      confirmationModal.componentInstance.confirmationDesc = text;
      confirmationModal.componentInstance.validateButtonText = 'Ok';
      return confirmationModal.result as Promise<boolean>;
    });
  }

  getAlertType() {
    switch (this.alertService.getType()!) {
      case AlertType.ERROR:
        return 'success';
      case AlertType.WARNING:
        return 'warning';
      case AlertType.SUCCESS:
        return 'success';
    }
  }

  onCloseAlert() {
    this.alertService.hide();
  }
}
